export default "__VITE_ASSET__DyiVLNMO__"